export default "__VITE_PUBLIC_ASSET__26de8935__"